import React from "react";

export default function OpsReports() {
  return (
    <div className="rounded-2xl border border-slate-200 p-4">
      <div className="text-lg font-extrabold">Ops Reports</div>
      <p className="mt-1 text-sm text-slate-600">
        Next: assignment time distribution, late pickup causes, SLA breach report, exports.
      </p>
    </div>
  );
}
